import { Preventif } from '@/models/Preventif';
import equipementInterventionsState, { EquipementInterventionsState } from './modules/state';
import { Periodicite, Vision } from '@/modules/Preventif/services/PreventifService';

export interface PreventifState {
    equipementInterventionsState: EquipementInterventionsState;

    preventif: Preventif[];
    displayPreventif: Preventif[];
    siteFilter: string,
    header: { dateDebut: string; dateFin: string }[];
    displayHeader: { dateDebut: string; dateFin: string }[];
    page: number;

    previsionnel: Vision;
    periodicite: Periodicite;

    nbPeriodesAffichees: number;
    nbPeriodesStep: number,

    isLoading: boolean;
    error?: Error;
    xlsInterventionsPreventivesLoading: boolean;
    isAllData: boolean;
    lastSiteId?: number;
    isUniqueSite: boolean;
}

export const initialState: PreventifState = {
    equipementInterventionsState,
    preventif: [],
    displayPreventif: [],
    siteFilter: '',
    header: [],
    displayHeader: [],
    page: 0,

    previsionnel: Vision.PREVISIONNELLE,
    periodicite: Periodicite.MENSUELLE,

    nbPeriodesAffichees: 12,
    nbPeriodesStep: 6,

    isLoading: true,
    error: undefined,
    xlsInterventionsPreventivesLoading: false,
    isAllData: false,
    isUniqueSite: false,
};

export const state = {
    ...initialState,
};
